var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Fade, SideImageLayout, StandardLayout } from 'hx-ui';
import { useSetProgress } from 'hx-progress';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { StyledProgress } from '@/components/styled-progress.component';
import { useLocation } from 'react-router-dom';
import { Footer } from './footer.component';
var eventMap = {
    '/setup/volume': 'volume',
    '/setup/info': 'tip',
};
function Nav() {
    var pathname = useLocation().pathname;
    var eventName = eventMap[pathname];
    return (_jsxs(NavigationButtonsContainer, { children: [_jsx(NavigationButton, { analyticsEvent: eventName && "".concat(eventName, "_previous"), type: "back", variant: "outlined", label: "Previous" }), _jsx(NavigationButton, { analyticsEvent: eventName && "".concat(eventName, "_next"), type: "submit", label: "Next" })] }));
}
export var StepLayout = function (_a) {
    var image = _a.image, heading = _a.heading, headingComponent = _a.headingComponent, subHeading = _a.subHeading, content = _a.content, info = _a.info, overlayedContent = _a.overlayedContent, _b = _a.nav, nav = _b === void 0 ? _jsx(Nav, {}) : _b, progress = _a.progress;
    useSetProgress(progress === null || progress === void 0 ? void 0 : progress.phase, progress === null || progress === void 0 ? void 0 : progress.step);
    return (_jsx(SideImageLayout, { leftPanelWidth: "40%", header: _jsx(StyledProgress, { className: "px-4 md:px-12 py-4", textClassName: 'font-bold' }), headingComponent: headingComponent, overlayedContent: overlayedContent, imageLeft: image, imageStyle: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
        }, footer: _jsx(Footer, {}), content: _jsx(StandardLayout, { contentHeader: heading ? (_jsxs(Fade, __assign({ className: "grid px-6 justify-center items-end min-h-[3rem] mx-auto" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl" }, { children: heading })), _jsx(Typography, __assign({ className: "text-xl" }, { children: subHeading }))] }))) : undefined, content: _jsx(Fade, __assign({ delay: 0.1, className: "grid pt-1 place-items-center" }, { children: content })), contentFooter: _jsx(Fade, __assign({ delay: 0.2, className: "grid gap-2 px-6 py-1 place-items-center" }, { children: info })) }), nav: nav }));
};
